<template>
  <div class="smartcenter">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>数智中心</el-breadcrumb-item>
          <el-breadcrumb-item>智能节点管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh"
         element-loading-background="rgba(0, 0, 0, 0.7)"
         class="main"
         :style="'background: url('+showImg+') no-repeat;'">
      <div class="float">
        <div class="white white1"></div>
        <div class="white white2"></div>
        <div class="white white3"></div>
        <div class="white white4"></div>
        <div class="white white5"></div>
        <div class="white white6"></div>
        <div class="white white7"></div>
        <div class="white white8"></div>
        <div class="white white9"></div>
        <div class="white white10"></div>
        <div class="blue blue1"></div>
        <div class="blue blue2"></div>
        <div class="blue blue3"></div>
        <div class="blue blue4"></div>
        <div class="blue blue5"></div>
        <div class="blue blue6"></div>
      </div>
      <!-- <div class="xian">
        <div class="xian1">1</div>
        <div class="xian2">2</div>
        <div class="xian3">3</div>
      </div> -->
      <div class="circleMove">
        <div v-if="showCount>1"
             class="circle circle1"></div>
        <div v-if="showCount==1 || showCount==3"
             class="circle circle2"></div>
        <div v-if="showCount>1"
             class="circle circle3"></div>
      </div>
      <div class="bigcircle bigcircle1"></div>
      <div class="bigcircle bigcircle2"></div>

      <!-- 弹窗 -->
      <div v-if="isPopUp"
           class="popup">
        <div class="bj"
             :style="'background: url(' + require('@/assets/smartcenter/popup.png')+ ') no-repeat'">
          <!-- <img src="@/assets/smartcenter/popup.png"
               alt=""> -->
          <img class="close"
               @click="isPopUp = false"
               src="@/assets/smartcenter/close.png"
               alt="">
          <div class="text">
            <h1>AI智能卡1</h1>
            <p>版本：v1.666</p>
            <p>温度：38.8℃</p>
            <p>CPU：30% <span style="margin:0 15px;">|</span> 内存：80%</p>
            <p>当前任务量：50 / 360</p>
          </div>
          <div class="float"
               style="top:51%;left:72%">
            <!-- <div class="white white1"></div> -->
            <!-- <div class="white white2"></div> -->
            <div class="white white3"></div>
            <div class="white white4"></div>
            <div class="white white5"></div>
            <div class="white white6"></div>
            <div class="white white7"></div>
            <!-- <div class="white white8"></div> -->
            <div class="white white9"></div>
            <div class="white white10"></div>
            <!-- <div class="blue blue1"></div>
            <div class="blue blue2"></div>
            <div class="blue blue3"></div>
            <div class="blue blue4"></div>
            <div class="blue blue5"></div>
            <div class="blue blue6"></div> -->
          </div>
          <!-- <div class="popfloat">
            <div class="popwhite popwhite1"></div>
            <div class="popwhite popwhite2"></div>
            <div class="popwhite popwhite3"></div>
            <div class="popwhite popwhite4"></div>
          </div> -->
        </div>
      </div>

      <div @click="isPopUp = true"
           v-if="showCount>1"
           class="aiarea1"></div>
      <div v-if="showCount==1 || showCount==3"
           @click="isPopUp = true"
           class="aiarea2"></div>
      <div @click="isPopUp = true"
           v-if="showCount>1"
           class="aiarea3"></div>

    </div>

  </div>
</template>

<script>


export default {
  components: {

  },

  data () {
    return {
      isRefresh: false,
      isPopUp: false,
      showCount: 3,
      showImg: require('@/assets/smartcenter/nobj.png')
    };
  },
  methods: {
    //刷新
    refresh () {
      if (this.showCount == 1) {
        this.showImg = require('@/assets/smartcenter/bj1.png')
      } else if (this.showCount == 2) {
        this.showImg = require('@/assets/smartcenter/bj2.png')
      } else if (this.showCount == 3) {
        this.showImg = require('@/assets/smartcenter/bj.png')
      }
      return;
      this.isRefresh = true
      setTimeout(() => {
        this.isRefresh = false
      }, 1000);
    }
  },
  created () {
    this.refresh()
  },
  beforeDestroy () {  // 组件销毁前调用

  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./smartcenter.scss";
</style>
